import ResourceManager from './resource.manager';
import config from '../utils/config';
import { TAResponse } from '../types';

class CompanyService extends ResourceManager {
	async getCompanyPermissionsStat() {
		return await this.getResource(config.URIs.get_company_permissions_stat);
	}

	async getCompanies(params: any = null, options: any = null, detailed = false): Promise<any> {
		return await this.getResource(detailed ? config.URIs.companies_uri : config.URIs.companies_summary_uri, {
			...(options || {}),
			params
		});
	}

	async getCompany(companyId) {
		return await this.getResource(config.URIs.get_company_uri.replace(/:companyId/g, companyId));
	}

	async generateCompanyContract(companyId, data) {
		return await this.postResource(config.URIs.get_company_contract_uri.replace(/:companyId/g, companyId), data);
	}

	async syncCompaniesStats() {
		return await this.postResource(config.URIs.sync_companies_stats, undefined);
	}

	async deleteCompany(companyId) {
		return await this.deleteResource(config.URIs.delete_company_uri.replace(/:companyId/g, companyId));
	}

	async getCompanyCandidates(companyId: string | null, params: any = null, options: any = null): Promise<any> {
		return await this.getResource(
			companyId
				? config.URIs.get_company_candidates_backoffice.replace(/:companyId/g, companyId)
				: config.URIs.get_company_candidates,
			{
				...(options || {}),
				params
			}
		);
	}

	async setVerifiedState(companyId, verified): Promise<TAResponse<any> | null> {
		return await this.putResource<undefined, TAResponse<any> | null>(
			config.URIs.set_company_verification_state.replace(/:companyId/, companyId) +
				'?state=' +
				(verified ? 1 : 0),
			undefined
		);
	}

	async setInterestedState(companyId, interested): Promise<TAResponse<any> | null> {
		return await this.putResource<undefined, TAResponse<any> | null>(
			config.URIs.set_company_interested_state.replace(/:companyId/, companyId) +
				'?state=' +
				(interested ? 1 : 0),
			undefined
		);
	}

	inviteCompany = async (url, data) => {
		return await this.postResource(url, data);
	};

	async getCompanyComments(companyId) {
		let resp: any = await this.getResource(config.URIs.get_company_comments.replace(/:companyId/g, companyId));
		return resp.data.map(comment => ({ ...comment, createdAt: new Date(comment.createdAt) }));
	}

	async commentOnCompany(companyId, comment, attachment) {
		var formData = new FormData(); // Currently empty
		formData.append('body', comment);
		formData.append('attachment', attachment);
		let resp: any = await this.postResource(
			config.URIs.comment_on_company.replace(/:companyId/g, companyId),
			formData
		);

		return {
			...resp.data.comment,
			createdAt: new Date(resp.data.comment.createdAt)
		};
	}

	async deleteCompanyComment(commentId) {
		let resp: any = await this.deleteResource(config.URIs.delete_company_comment.replace(/:commentId/g, commentId));

		return resp.success;
	}

	async editCompanyComment(commentId, comment) {
		let resp: any = await this.putResource(config.URIs.edit_company_comment.replace(/:commentId/g, commentId), {
			body: comment
		});

		return resp.success;
	}
	async updateCompany(data, companyId) {
		const response: any = await this.putResource(
			config.URIs.update_company_profile.replace(/:companyId/g, companyId),
			data
		);
		return response;
	}

	async getFaqQuestions(): Promise<any> {
		return await this.getResource(config.URIs.get_faq_questions);
	}

	async getpackageOrdersInvoices() {
		return await this.getResource(config.URIs.get_package_order_invoices);
	}

	async setJobsAccess(enabled): Promise<TAResponse<any> | null> {
		return await this.patchResource(config.URIs.set_jobs_controlled_access, { enabled });
	}

	async getUnPaidInvoices() {
		return await [
			{ id: 6, type: 'Interview Package', issueDate: new Date(), amount: '50', packageTitle: 'High-tier Plan' },
			{ id: 7, type: 'Interview Package', issueDate: new Date(), amount: '60', packageTitle: 'High-tier Plan' },
			{ id: 8, type: 'Successful Hiring', issueDate: new Date(), amount: '70' },
			{ id: 9, type: 'Interview Package', issueDate: new Date(), amount: '80', packageTitle: 'Medium-tier Plan' },
			{ id: 10, type: 'Successful Hiring', issueDate: new Date(), amount: '90' }
		];
	}
}

export default new CompanyService();
